import type { ReactNode } from 'react';

export function findChild<T>(children: ReactNode[], childType: T) {
  return children.find(child => (
    // @ts-ignore
    child.type === childType
  ));
}
